const ANALYTICS_SUBJECT_DOMAIN = 'tribelog-analytics-subject:v1|';
const ANALYTICS_SUBJECT_PREFIX = 'a1_';
const SHA256_HEX = /^[a-f0-9]{64}$/;

function normalizedFirebaseUid(firebaseUid) {
  if (
    typeof firebaseUid !== 'string'
    || firebaseUid.length < 1
    || firebaseUid.length > 128
    || firebaseUid.trim() !== firebaseUid
    || /[\p{Cc}\p{Z}\s@]/u.test(firebaseUid)
  ) {
    return null;
  }
  return firebaseUid;
}

async function sha256Hex(value) {
  const subtle = globalThis.crypto?.subtle;
  if (!subtle || typeof TextEncoder === 'undefined') {
    throw new Error('SHA-256 is unavailable.');
  }
  const bytes = new TextEncoder().encode(value);
  const digest = await subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
}

async function buildAnalyticsSubjectId(firebaseUid, digest = sha256Hex) {
  const uid = normalizedFirebaseUid(firebaseUid);
  if (!uid || typeof digest !== 'function') return null;
  const digestHex = await digest(`${ANALYTICS_SUBJECT_DOMAIN}${uid}`);
  if (typeof digestHex !== 'string' || !SHA256_HEX.test(digestHex)) return null;
  return `${ANALYTICS_SUBJECT_PREFIX}${digestHex}`;
}

export {
  ANALYTICS_SUBJECT_DOMAIN,
  ANALYTICS_SUBJECT_PREFIX,
  buildAnalyticsSubjectId,
  normalizedFirebaseUid,
  sha256Hex,
};
